/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_It_Works_TitleInputs */

const en_landing_how_it_works_title = /** @type {(inputs: Landing_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From published research to AI-ready data`)
};

/**
* | output |
* | --- |
* | "From published research to AI-ready data" |
*
* @param {Landing_How_It_Works_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_how_it_works_title = /** @type {((inputs?: Landing_How_It_Works_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_It_Works_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_how_it_works_title(inputs)
});